import React from "react";
import AuthLayout from "../../layouts/AuthLayout";
import { useLocation } from "react-router-dom";

const OffSiteSource = () => {
  const location = useLocation();
  console.log(location);
  return (
    <AuthLayout>
      <div className="flex flex-col items-center justify-center w-full h-full my-12">
        <div dangerouslySetInnerHTML={{ __html: location.state.url }} />
      </div>
    </AuthLayout>
  );
};

export default OffSiteSource;
